import React from "react";
import LottieAnimation from "../helpers/LottieAnimation";

function LoadingPage() {
  return (
    <div
      style={{ height: "80vh" }}
      role="status"
      aria-label="Se încarcă"
      className="flex items-center justify-center">
      <LottieAnimation type="loading" height="40%" width="40%" />
    </div>
  );
}

export default LoadingPage;
